import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { TripCategory } from "@b2bportal/core-types";
import {
  CoreFlightSteps,
  ensureExhaustive,
  FlightsNavigationFlow,
} from "@b2bportal/core-utilities";
import { getTripCategory } from "../../search/store/selectors";
import { FlightShopSelectors } from "../store";

export const useValidateFlightShopRoute = (currentStep: CoreFlightSteps) => {
  const hasSelectedDepartureFlight = useSelector(
    FlightShopSelectors.hasSelectedDepartureFlights
  );
  const hasSelectedReturnFlight = useSelector(
    FlightShopSelectors.hasSelectedReturnFlights
  );

  const tripCategory = useSelector(getTripCategory);
  const goToStep = FlightsNavigationFlow.useGoToStep();

  const goToDepartureStep = () => goToStep(CoreFlightSteps.DEPARTURE, true);
  const [valid, setValid] = useState(false);

  useEffect(() => {
    switch (currentStep) {
      case CoreFlightSteps.RETURN: {
        !hasSelectedDepartureFlight ? goToDepartureStep() : setValid(true);
        break;
      }
      case CoreFlightSteps.REVIEW:
      case CoreFlightSteps.REVIEW_FARE: {
        switch (tripCategory) {
          case TripCategory.ONE_WAY: {
            !hasSelectedDepartureFlight ? goToDepartureStep() : setValid(true);
            break;
          }
          case TripCategory.ROUND_TRIP: {
            !hasSelectedReturnFlight ? goToDepartureStep() : setValid(true);
            break;
          }
          default:
            ensureExhaustive(tripCategory);
        }
        break;
      }
      case CoreFlightSteps.SEARCH:
      case CoreFlightSteps.DEPARTURE:
      case CoreFlightSteps.BOOK: {
        break;
      }
      default:
        ensureExhaustive(currentStep);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return valid;
};
